import { Link } from 'react-router-dom';
import type { ComicItem } from '@/mocks/types';

interface ComicCardProps {
  comic: ComicItem;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const viewsText = comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views.toString();

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={comic.coverImage}
          alt={`${comic.title} 韩漫漫画`}
          title={`${comic.title} - 热门韩漫推荐`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2 flex gap-1.5">
          {comic.isHot && (
            <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-primary-500 text-background-50 whitespace-nowrap">
              热门
            </span>
          )}
          {comic.isNew && (
            <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
              新作
            </span>
          )}
        </div>
        <div className="absolute top-2 right-2">
          <span className={`px-2 py-0.5 rounded-md text-xs font-medium whitespace-nowrap ${
            comic.status === 'ongoing' ? 'bg-secondary-500 text-background-50' : 'bg-background-800 text-background-200'
          }`}>
            {comic.status === 'ongoing' ? '连载中' : '已完结'}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
          <div className="flex items-center gap-3 text-background-50 text-xs">
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-star-fill text-accent-400"></i>
              {comic.rating}
            </span>
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-eye-line"></i>
              {viewsText}
            </span>
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-file-list-3-line"></i>
              {comic.chapters}话
            </span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors whitespace-nowrap overflow-hidden text-ellipsis">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{comic.author}</p>
        <div className="flex flex-wrap gap-1 mt-2">
          {comic.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-1.5 py-0.5 rounded text-xs bg-background-100 text-foreground-600 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}